class NavCollapsed {
	constructor($el) {
		this.state = {
			foldoutIsOpen: false,
			searchIsOpen: false,
		}

		this.$el = $el
		this.$topBar = this.$el.querySelector(".js--nav-collapsed__top-bar")
		this.$hamburger = this.$el.querySelector(
			".js--nav-collapsed__toggle-foldout"
		)
		this.$foldout = this.$el.querySelector(".js--nav-collapsed__foldout")
		this.$triggersSubmenu = this.$el.querySelectorAll(
			".js--nav-collapsed__open-submenu"
		)
		this.$submenus = this.$el.querySelectorAll(".js--nav-collapsed__submenu")
		this.$backs = this.$el.querySelectorAll(".js--nav-collapsed__back")
		this.$firstScreen = this.$el.querySelector(
			".js--nav-collapsed__first-screen"
		)
		this.$toggleSearch = this.$el.querySelector(".js--nav__toggle-search")
		this.$searchFoldout = this.$el.querySelector(".js--nav__search-foldout")
    this.$searchInput = this.$el.querySelector(".js--nav__search-input")
    this.$searchSubmit = this.$el.querySelector(".js--nav__search-submit")
    this.$quickLinks = this.$el.querySelectorAll(".js--nav__search-quicklink")
		this.$searchRoot = this.$el.dataset.searchUrl
	}

	init() {
		this.handleClickToggleFoldout()
		this.handleClickSubmenu()
		this.handleClickBack()
		this.handleToggleSearch()

    if (this.$searchInput) {
      this.$searchInput.addEventListener("keyup", (e) => {
				this.$searchInput.classList.remove("error")
				if (e.key === "Enter" || e.keyCode === 13) {
					this.submitSearch()
				}
			})

			this.$searchSubmit.addEventListener("click", () => {
				this.submitSearch()
			})

			this.$quickLinks.forEach(($link) => {
				$link.addEventListener("click", (e) => {
					e.preventDefault()
          window.location.href = `${this.$searchRoot}#?query=${$link.dataset.searchterm}`
          if (document.querySelector("[data-issearchpage]")) {
						window.location.reload()
					}
				})
			})
    }

		document.addEventListener(
			"click",
			(e) => {
				if (this.$searchFoldout) {
					const $isSearchTriggerClicked = this.$toggleSearch.contains(e.target)
					const $isSearchFoldoutClicked = this.$searchFoldout.contains(e.target)
					if (!$isSearchFoldoutClicked && !$isSearchTriggerClicked) {
						this.closeSearch()
					}
				}
			},
			false
		)
	}

	handleClickToggleFoldout() {
		if (this.$hamburger !== null) {
			this.$hamburger.addEventListener("click", () => {
				if (!this.state.foldoutIsOpen) {
					this.closeSearch()
					this.openFoldout()
				} else {
					this.closeFoldout()
				}
			})
		}
	}

	openFoldout() {
		// calculate visible screen size (100vh) don't work on iOS
		const topBarDimensions = this.$topBar.getBoundingClientRect()
		this.$foldout.style.height = `${
			window.innerHeight - topBarDimensions.height
		}px`
		this.state.foldoutIsOpen = true
		this.$hamburger.setAttribute("aria-expanded", "true")
		this.$foldout.classList.add("is-open")
	}

	closeFoldout() {
		this.state.foldoutIsOpen = false
		this.$hamburger.setAttribute("aria-expanded", "false")
		this.$foldout.classList.remove("is-open")
	}

	handleClickSubmenu() {
		for (const $trigger of this.$triggersSubmenu) {
			$trigger.addEventListener("click", (e) => {
				e.preventDefault()
				for (const $submenu of this.$submenus) {
					if ($submenu.id === $trigger.dataset.submenuId) {
						this.$el
							.querySelector(`#${$trigger.dataset.parentId}`)
							.classList.add("has-open-submenu")
						$submenu.classList.add("to-open")
						$submenu.classList.add("is-open")
						setTimeout(() => {
							$submenu.classList.remove("to-open")
						}, 250)
					}
				}
			})
		}
	}

	handleClickBack() {
		for (const $trigger of this.$backs) {
			$trigger.addEventListener("click", (e) => {
				for (const $submenu of this.$submenus) {
					if ($submenu.id === $trigger.dataset.submenuId) {
						$submenu.classList.add("from-open")
						setTimeout(() => {
							$submenu.classList.remove("from-open")
							$submenu.classList.remove("is-open")
							this.$el
								.querySelector(`#${$trigger.dataset.parentId}`)
								.classList.remove("has-open-submenu")
						}, 250)
					}
				}
			})
		}
	}

	handleToggleSearch() {
		if (this.$toggleSearch !== null) {
			this.$toggleSearch.addEventListener("click", () => {
				this.closeFoldout()
				if (this.state.searchIsOpen) {
					this.closeSearch()
				} else {
					this.openSearch()
				}
			})
		}
	}

	openSearch() {
		if (this.$searchFoldout !== null) {
			this.state.searchIsOpen = true
			this.$searchFoldout.classList.add("is-open")
			this.$toggleSearch.classList.add("active")
			setTimeout(() => {
				this.$searchInput.focus()
				window.addEventListener("click", this.clickOutsideSearch)
			}, 250)
		}
	}

	closeSearch() {
		if (this.$searchFoldout !== null) {
			this.state.searchIsOpen = false
			this.$searchFoldout.classList.remove("is-open")
			this.$toggleSearch.classList.remove("active")
		}
	}

	submitSearch() {
		const searchTerm = this.$searchInput.value
		if (searchTerm.length === 0) {
			this.$searchInput.classList.add("error")
		} else {
      window.location.href = `${this.$searchRoot}#?query=${searchTerm}`
			if (document.querySelector("[data-issearchpage]")) {
				window.location.reload()
			}
		}
	}
}


[...document.querySelectorAll('.js--nav-collapsed')].forEach($el => {
  const inst = new NavCollapsed($el);
  inst.init();
});
